export const STARTUP = 'currentuser/STARTUP';
export const COUNTERS = 'currentuser/COUNTERS';